var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('the-header',{ref:"theHeader",staticClass:"sticky-top"}),_c('main',{on:{"click":function($event){return _vm.$refs.theHeader.close()}}},[_c('h4',{staticClass:"title-header"},[_vm._v("MSDAT Configurer")]),(_vm.showSteps)?_c('stepper',{staticClass:"text-center"}):_vm._e(),(_vm.isWelcome)?_c('landing'):_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }